export const COURSE_ENTITY_NAME = 'CUR_COURSE';
export const DOCUMENT_ENTITY_NAME = 'SDC_DOCUMENT';
export const COURSE_FORM_KEY = 'CUR_COURSE_SIGNOFF_CONTENT';
export const DOCUMENT_FORM_KEY = 'SDC_DOCUMENT_SIGNOFF_CONTENT';
export const CONTENT_TYPES = ['DOCUMENT', 'COURSE'];
export const PERSON_CERTIFICATION_ENTITY_NAME = 'PSN_PERSON';
export const PERSON_TRAINER_CERTIFICATION_FORM_KEY = 'PSN_PERSON_TRAINER_CERTIFICATION_SIGNOFF';
export const PERSON_CERTIFICATION_FORM_KEY = 'PSN_PERSON_CERTIFICATION_READ_SIGNOFF';
export const ACTOR_CERTIFICATION_ENTITY_NAME = 'IAC_INTERNAL_ACTOR';
export const ACTOR_CERTIFICATION_FORM_KEY = 'IAC_INTERNAL_ACTOR_CERTIFICATION_READ_SIGNOFF';
export const ACTOR_TRAINER_CERTIFICATION_FORM_KEY =
  'IAC_INTERNAL_ACTOR_TRAINER_CERTIFICATION_SIGNOFF';
export const SET_SUBMIT_INITIATED = 'SET_SUBMIT_INITIATED';
export const CERTIFICATION_CONTENT_DISPLAY = 'RIGHT';
